(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["@big-d-companies/icons"] = factory();
	else
		root["@big-d-companies/icons"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ArrowIcon: () => (/* reexport */ icon_arrow),
  ArrowIcon2: () => (/* reexport */ icon_arrow2),
  ChevronDownIcon: () => (/* reexport */ icon_chevron_down),
  CloseIcon: () => (/* reexport */ icon_close),
  FacebookIcon: () => (/* reexport */ icon_facebook),
  FullscreenIcon: () => (/* reexport */ icon_fullscreen),
  HamburgerIcon: () => (/* reexport */ icon_hamburg),
  InstagramIcon: () => (/* reexport */ icon_instagram),
  LinkedInIcon: () => (/* reexport */ icon_linkedin),
  PauseIcon: () => (/* reexport */ icon_pause),
  PlayIcon: () => (/* reexport */ icon_play),
  SlopedArrowIcon: () => (/* reexport */ icon_arrow_sloped),
  SmallPlayIcon: () => (/* reexport */ icon_play_small),
  StarIcon: () => (/* reexport */ icon_star),
  StarsIcon: () => (/* reexport */ icon_stars),
  ThinArrowIcon: () => (/* reexport */ icon_arrow_thin),
  TwitterIcon: () => (/* reexport */ icon_twitter),
  XTwitterIcon: () => (/* reexport */ icon_x_twitter),
  YouTubeIcon: () => (/* reexport */ icon_youtube)
});

;// CONCATENATED MODULE: external "react"
const external_react_namespaceObject = require("react");
;// CONCATENATED MODULE: ./src/icon-arrow.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgIconArrow = function SvgIconArrow(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 14"
  }, props), _path || (_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.03.47 19.56 7l-6.53 6.53-1.06-1.06 4.72-4.72H.5v-1.5h16.19l-4.72-4.72z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const icon_arrow = (SvgIconArrow);
;// CONCATENATED MODULE: ./src/icon-arrow2.svg
function icon_arrow2_extends() { return icon_arrow2_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_arrow2_extends.apply(null, arguments); }

var SvgIconArrow2 = function SvgIconArrow2(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_arrow2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188 142"
  }, props), /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M1 67h179v9H1zm116 74.7-7.1-7.1L173.6 71 109.9 7.4 117 .3 187.7 71z",
    style: {
      fill: "#fff"
    }
  }));
};
/* harmony default export */ const icon_arrow2 = (SvgIconArrow2);
;// CONCATENATED MODULE: ./src/icon-arrow-sloped.svg
var _defs, _use;
function icon_arrow_sloped_extends() { return icon_arrow_sloped_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_arrow_sloped_extends.apply(null, arguments); }

var SvgIconArrowSloped = function SvgIconArrowSloped(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_arrow_sloped_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10"
  }, props), _defs || (_defs = /*#__PURE__*/external_react_namespaceObject.createElement("defs", null, /*#__PURE__*/external_react_namespaceObject.createElement("image", {
    id: "icon-arrow-sloped_svg__a",
    width: 10,
    height: 10,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAAAXNSR0IB2cksfwAAAAZQTFRF////////VXz1bAAAAAJ0Uk5T/wDltzBKAAAAI0lEQVR4nGNgAIM/DAw/GBg+MjA8ZmA4zsDQz8Agz8BgzwAAVKsFfdBMYlwAAAAASUVORK5CYII="
  }))), _use || (_use = /*#__PURE__*/external_react_namespaceObject.createElement("use", {
    href: "#icon-arrow-sloped_svg__a"
  })));
};
/* harmony default export */ const icon_arrow_sloped = (SvgIconArrowSloped);
;// CONCATENATED MODULE: ./src/icon-arrow-thin.svg
var icon_arrow_thin_path;
function icon_arrow_thin_extends() { return icon_arrow_thin_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_arrow_thin_extends.apply(null, arguments); }

var SvgIconArrowThin = function SvgIconArrowThin(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_arrow_thin_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187 142"
  }, props), icon_arrow_thin_path || (icon_arrow_thin_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    fillRule: "evenodd",
    d: "m116 141.7-7-7L167.5 76H0v-9h168.6L108.9 7.4 116 .3 186.7 71z"
  })));
};
/* harmony default export */ const icon_arrow_thin = (SvgIconArrowThin);
;// CONCATENATED MODULE: ./src/icon-chevron-down.svg
var icon_chevron_down_path;
function icon_chevron_down_extends() { return icon_chevron_down_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_chevron_down_extends.apply(null, arguments); }

var SvgIconChevronDown = function SvgIconChevronDown(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_chevron_down_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    className: "icon-chevron-down_svg__feather icon-chevron-down_svg__feather-chevron-down",
    viewBox: "0 0 24 24"
  }, props), icon_chevron_down_path || (icon_chevron_down_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "m6 9 6 6 6-6"
  })));
};
/* harmony default export */ const icon_chevron_down = (SvgIconChevronDown);
;// CONCATENATED MODULE: ./src/icon-close.svg
var icon_close_path;
function icon_close_extends() { return icon_close_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_close_extends.apply(null, arguments); }

var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_close_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), icon_close_path || (icon_close_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "m15.5 1-14 14m14-14-14 14M2 1l14 14M2 1l14 14"
  })));
};
/* harmony default export */ const icon_close = (SvgIconClose);
;// CONCATENATED MODULE: ./src/icon-facebook.svg
var icon_facebook_path;
function icon_facebook_extends() { return icon_facebook_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_facebook_extends.apply(null, arguments); }

var SvgIconFacebook = function SvgIconFacebook(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_facebook_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 14"
  }, props), icon_facebook_path || (icon_facebook_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    fillRule: "evenodd",
    d: "M2.552 13.997V7.429H.591V5.64h1.961V3.43C2.552 1.457 3.711 0 6.381 0c1.081 0 1.881.92 1.881.92l-.063 1.379s-.816-.007-1.705-.007c-.963 0-1.117.392-1.117 1.045V5.64h2.898l-.126 1.789H5.377v6.568z"
  })));
};
/* harmony default export */ const icon_facebook = (SvgIconFacebook);
;// CONCATENATED MODULE: ./src/icon-fullscreen.svg
var icon_fullscreen_path;
function icon_fullscreen_extends() { return icon_fullscreen_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_fullscreen_extends.apply(null, arguments); }

var SvgIconFullscreen = function SvgIconFullscreen(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_fullscreen_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), icon_fullscreen_path || (icon_fullscreen_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M6.775 1v1.664h2.292L6.225 5.437l-3.392 3.42V6.824H1V12h5.317v-1.664H4.025l6.233-6.286v2.034H12V1z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const icon_fullscreen = (SvgIconFullscreen);
;// CONCATENATED MODULE: ./src/icon-hamburg.svg
var icon_hamburg_path;
function icon_hamburg_extends() { return icon_hamburg_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_hamburg_extends.apply(null, arguments); }

var SvgIconHamburg = function SvgIconHamburg(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_hamburg_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 8"
  }, props), icon_hamburg_path || (icon_hamburg_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    fillRule: "evenodd",
    d: "M0 7.999v-2h19.999v2zM0 0h19.999v1.999H0z"
  })));
};
/* harmony default export */ const icon_hamburg = (SvgIconHamburg);
;// CONCATENATED MODULE: ./src/icon-instagram.svg
var icon_instagram_path;
function icon_instagram_extends() { return icon_instagram_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_instagram_extends.apply(null, arguments); }

var SvgIconInstagram = function SvgIconInstagram(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_instagram_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 14"
  }, props), icon_instagram_path || (icon_instagram_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M7.023 3.39c-2 0-3.593 1.626-3.593 3.594 0 2 1.593 3.594 3.593 3.594a3.594 3.594 0 0 0 3.594-3.594c0-1.968-1.625-3.593-3.594-3.593m0 5.938A2.34 2.34 0 0 1 4.68 6.984c0-1.28 1.03-2.312 2.343-2.312a2.307 2.307 0 0 1 2.313 2.312c0 1.313-1.031 2.344-2.313 2.344m4.563-6.062a.84.84 0 0 0-.844-.844.84.84 0 0 0-.844.844.84.84 0 0 0 .844.843.84.84 0 0 0 .844-.843m2.375.843c-.063-1.125-.313-2.125-1.125-2.937C12.023.359 11.023.109 9.898.047c-1.156-.063-4.625-.063-5.78 0C2.991.109 2.022.359 1.18 1.172.367 1.984.117 2.984.055 4.109c-.063 1.157-.063 4.625 0 5.782.062 1.125.312 2.093 1.125 2.937.843.813 1.812 1.063 2.937 1.125 1.156.063 4.625.063 5.781 0 1.125-.062 2.125-.312 2.938-1.125.812-.844 1.062-1.812 1.125-2.937.062-1.157.062-4.625 0-5.782m-1.5 7c-.219.625-.719 1.094-1.313 1.344-.937.375-3.125.281-4.125.281-1.03 0-3.218.094-4.125-.28a2.37 2.37 0 0 1-1.343-1.345c-.375-.906-.282-3.093-.282-4.125 0-1-.093-3.187.282-4.125a2.4 2.4 0 0 1 1.343-1.312c.907-.375 3.094-.281 4.125-.281 1 0 3.188-.094 4.125.28.594.22 1.063.72 1.313 1.313.375.938.281 3.125.281 4.125 0 1.032.094 3.22-.281 4.125"
  })));
};
/* harmony default export */ const icon_instagram = (SvgIconInstagram);
;// CONCATENATED MODULE: ./src/icon-linkedin.svg
var icon_linkedin_path;
function icon_linkedin_extends() { return icon_linkedin_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_linkedin_extends.apply(null, arguments); }

var SvgIconLinkedin = function SvgIconLinkedin(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_linkedin_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 13"
  }, props), icon_linkedin_path || (icon_linkedin_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M13 13h-2.7V8.8c0-1 0-2.3-1.4-2.3s-1.6 1-1.6 2.2V13H4.6V4.3h2.6v1.2A2.8 2.8 0 0 1 9.7 4C12.5 4 13 5.9 13 8.2zM1.6 3.1A1.6 1.6 0 1 1 3 1.6 1.6 1.6 0 0 1 1.6 3m1.3 1.3H.2V13H3V4.3z"
  })));
};
/* harmony default export */ const icon_linkedin = (SvgIconLinkedin);
;// CONCATENATED MODULE: ./src/icon-pause.svg
var icon_pause_path;
function icon_pause_extends() { return icon_pause_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_pause_extends.apply(null, arguments); }

var SvgIconPause = function SvgIconPause(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_pause_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), icon_pause_path || (icon_pause_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M8 12V1h4v11zm-7 0V1h4v11z",
    clipRule: "evenodd"
  })));
};
/* harmony default export */ const icon_pause = (SvgIconPause);
;// CONCATENATED MODULE: ./src/icon-play.svg
function icon_play_extends() { return icon_play_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_play_extends.apply(null, arguments); }

var SvgIconPlay = function SvgIconPlay(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_play_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/external_react_namespaceObject.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M55.4 50.3v20l15.3-10z",
    style: {
      fill: "#333"
    }
  }));
};
/* harmony default export */ const icon_play = (SvgIconPlay);
;// CONCATENATED MODULE: ./src/icon-play-small.svg
var icon_play_small_path;
function icon_play_small_extends() { return icon_play_small_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_play_small_extends.apply(null, arguments); }

var SvgIconPlaySmall = function SvgIconPlaySmall(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_play_small_extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), icon_play_small_path || (icon_play_small_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M2 1v11l9-5.5z"
  })));
};
/* harmony default export */ const icon_play_small = (SvgIconPlaySmall);
;// CONCATENATED MODULE: ./src/icon-star.svg
var icon_star_path;
function icon_star_extends() { return icon_star_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_star_extends.apply(null, arguments); }

var SvgIconStar = function SvgIconStar(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_star_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 35"
  }, props), icon_star_path || (icon_star_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    fillRule: "evenodd",
    d: "M28.725 22.41 31 34.912 19.43 29.13 7.861 34.912l2.275-12.502-9.639-9.49 13.321-1.48L19.43.6l6 10.84 12.933 1.48z"
  })));
};
/* harmony default export */ const icon_star = (SvgIconStar);
;// CONCATENATED MODULE: ./src/icon-stars.svg
var icon_stars_path;
function icon_stars_extends() { return icon_stars_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_stars_extends.apply(null, arguments); }

var SvgIconStars = function SvgIconStars(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_stars_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221 35"
  }, props), icon_stars_path || (icon_stars_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M28.7 22.4 31 35l-11.6-5.8L8 35l2-12.6L.5 13l13.3-1.5L19.4.6l6 10.8 13 1.5zm45.6 0L76.6 35l-11.1-5.8-12 5.8 2.2-12.5-9-9.5 12.7-1.5L65.5.6l5.1 10.8L84 13l-9.6 9.5Zm91.1 0 2.3 12.5-11.5-5.8-11.6 5.8 2.3-12.5-9.7-9.5 13.3-1.5L156.2.6l5.6 10.8 14 1.5zm45.8 0 2.1 12.5-11.6-5.8-11.5 5.8 2.2-12.5-9.6-9.5 13.3-1.5L201.7.6l5.6 10.8 13.4 1.5zm-91.3 0L122 35l-11.5-5.8L99 35l2.2-12.5-9.7-9.5 13.4-1.5L110.6.6l5.6 10.8 13.3 1.5z"
  })));
};
/* harmony default export */ const icon_stars = (SvgIconStars);
;// CONCATENATED MODULE: ./src/icon-twitter.svg
var icon_twitter_path;
function icon_twitter_extends() { return icon_twitter_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_twitter_extends.apply(null, arguments); }

var SvgIconTwitter = function SvgIconTwitter(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_twitter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 14"
  }, props), icon_twitter_path || (icon_twitter_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    fillRule: "evenodd",
    d: "M18.659 1.655a8 8 0 0 1-2.199.557c.79-.437 1.397-.382 1.683-1.954a8.1 8.1 0 0 1-2.431.858C15.14.428 14.19 0 12.918 0 10.804 0 9.9 1.581 9.9 3.533c0 .277-.776 1.257-.711.806C6.7 4.191 3.187 2.785 1.299.646A3.3 3.3 0 0 0 .78 2.422c0 1.227.676 2.308 1.703 2.943a4.1 4.1 0 0 1-1.734-.444v.046c0 1.713 1.941 3.14 3.071 3.465a4 4 0 0 1-1.009.124c-.246 0-.486-.022.099-.063-.332 1.403 1.082 2.425 2.757 2.455A8.1 8.1 0 0 1 .913 12.46q-.464 0-.913-.049a11.5 11.5 0 0 0 5.868 1.587c7.041 0 10.892-5.386 10.892-10.056q0-.228-.011-.456a7.5 7.5 0 0 0 1.91-1.831"
  })));
};
/* harmony default export */ const icon_twitter = (SvgIconTwitter);
;// CONCATENATED MODULE: ./src/icon-x-twitter.svg
var icon_x_twitter_path;
function icon_x_twitter_extends() { return icon_x_twitter_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_x_twitter_extends.apply(null, arguments); }

var SvgIconXTwitter = function SvgIconXTwitter(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_x_twitter_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1227"
  }, props), icon_x_twitter_path || (icon_x_twitter_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M714.163 519.284 1160.89 0h-105.86L667.137 450.887 357.328 0H0l468.492 681.821L0 1226.37h105.866l409.625-476.152 327.181 476.152H1200L714.137 519.284zM569.165 687.828l-47.468-67.894-377.686-540.24h162.604l304.797 435.991 47.468 67.894 396.2 566.721H892.476L569.165 687.854z"
  })));
};
/* harmony default export */ const icon_x_twitter = (SvgIconXTwitter);
;// CONCATENATED MODULE: ./src/icon-youtube.svg
var icon_youtube_path;
function icon_youtube_extends() { return icon_youtube_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, icon_youtube_extends.apply(null, arguments); }

var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/external_react_namespaceObject.createElement("svg", icon_youtube_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 14"
  }, props), icon_youtube_path || (icon_youtube_path = /*#__PURE__*/external_react_namespaceObject.createElement("path", {
    d: "M15.3.1H3.4C.4.3 0 2.1 0 7c0 4.8.4 6.6 3.4 6.9h11.9c3-.3 3.3-2 3.4-6.9 0-4.8-.4-6.6-3.4-6.9M7 10.1V4l6.2 3L7 10.2Z"
  })));
};
/* harmony default export */ const icon_youtube = (SvgIconYoutube);
;// CONCATENATED MODULE: ./src/index.js






















/******/ 	return __webpack_exports__;
/******/ })()
;
});